import ErrorBoundary from './ErrorBoundary';
import BoardError from './BoardError';
import ConfigProvider from './lib/config-provider';
import Board from './Board';
import { ERROR_BOUNDARY_NAME } from './lib/constants';
import { jsx as _jsx } from "react/jsx-runtime";
const App = props => {
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    ErrorComponent: BoardError,
    boundaryName: ERROR_BOUNDARY_NAME,
    onComponentDidCatch: error => {
      if (typeof props.onErrorCaught === 'function') props.onErrorCaught(ERROR_BOUNDARY_NAME, error);
    },
    children: /*#__PURE__*/_jsx(ConfigProvider, Object.assign({}, props, {
      children: /*#__PURE__*/_jsx(Board, Object.assign({}, props))
    }))
  });
};
export default App;